import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './translations';

// Get saved language preference or default to Bulgarian
const savedLanguage = localStorage.getItem('adminLanguage') || 'bg';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'bg',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;